/**
 * Used on the template "Contentpagina met tabs - alternatief"
 */
export class FixedTabs {

  constructor() {
    this.$tabsBar = $('.page-tabs-alt-wrapper');
    if (this.$tabsBar.length === 0) {
      return;
    }

    this.$mobileCollapse = $('.page-tabs-alt__item--mobile');
    this.$hiddenFilters = $('.page-tabs-alt__item--hidden');
    this.$itemLink = $('.page-tabs-alt__item--link');

    this.minOffset = this.$tabsBar.offset().top;
    this.showMoreTitle = this.$mobileCollapse.text();

    // bind events
    $(window).on('scroll', () => this.scrollCheck());
    this.$itemLink.on('click', e => this.itemClicked(e));
    this.$mobileCollapse.on('click', (e) => {
      e.preventDefault();
      this.toggleFiltersOnMobile($(e.currentTarget));
    });
  }

  scrollCheck() {
    const scroll = $(window).scrollTop();
    const offset = 115;
    this.$tabsBar[(scroll + offset >= this.minOffset) ? 'addClass' : 'removeClass']('fixed');
  }

  itemClicked(e) {
    const $this = $(e.currentTarget);
    const anchor = $this.attr('href');
    e.preventDefault();

    // Offset via DOM element to prevent jumping
    // after window.location.hash change:
    $(anchor).css({
      display: 'block',
      position: 'relative',
      top: -300,
    });

    if (this.isMobile()) {
      this.$hiddenFilters.toggle();
      this.toggleFiltersOnMobile(this.$mobileCollapse);
    }

    $(window).scrollTo(anchor, 500, {
      onAfter: /* istanbul ignore next */ () => window.location.hash = anchor,
    });
  }

  toggleFiltersOnMobile($this) {
    const isActive = $this.hasClass('active');
    this.$hiddenFilters[ isActive ? 'hide' : 'show' ]();
    $this.text( isActive ? this.showMoreTitle : 'Navigatie verbergen' );
    $this[ isActive ? 'removeClass' : 'addClass' ]('active');
  }

  isMobile() {
    return $(window).width() < 767;
  }
}
